import { getAmplitudeInstance } from '../amplitudeHelpers';
import FeedbackProvided from '../enums/FeedbackProvided';

type logAskAllTrailsFeedbackSubmittedParams = {
  comment: string;
  feedback?: FeedbackProvided;
  query_id?: string;
  session_id?: string;
};

/**
 * User submits written feedback on an Ask AllTrails response from the feedback modal. Logged only when the feedback text is not empty, so it undercounts ratings. Use AskAllTrailsFeedbackRated as the source of truth for thumbs up and thumbs down counts.
 * @param params - Attributes to log with the amplitude event
 * @param params.comment - The open-text feedback provided by the user.
 * @param params.feedback - Binary feedback on the response. Use helpful or not helpful.
 * @param params.query_id - Unique id of the query the feedback applies to.
 * @param params.session_id - Unique id for a continuous Ask AllTrails session.
 */
const logAskAllTrailsFeedbackSubmitted = (
  { comment, feedback, query_id, session_id }: logAskAllTrailsFeedbackSubmittedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'ask all trails feedback submitted',
    { comment, feedback, 'query id': query_id, 'session id': session_id },
    callback
  );
};

export default logAskAllTrailsFeedbackSubmitted;
